import React, { useState } from "react";
import { Icon } from "MODULES/shared/components";
import DropDownItem from "MODULES/shared/components/DropDown/DropDownItem";
import withCurrentUser from "MODULES/session/decorators/withCurrentUser";
import { withRma } from "MODULES/RMAsAndWarranties/decorators";
import { PDF_TYPES } from "MODULES/RMAsAndWarranties/components/Detail/Actions/PrintRma";
import Modal from "./Modal";

function Send({ rma, type }) {
  const [sendModalVisible, setSendModalIsVisible] = useState(false);

  return (
    <DropDownItem onClick={() => setSendModalIsVisible(true)}>
      <Icon name="envelope" fixed />
      &nbsp;{PDF_TYPES[type].label}
      <Modal
        open={sendModalVisible}
        close={() => setSendModalIsVisible(false)}
        rma={rma.toJS()}
        type={type}
      />
    </DropDownItem>
  );
}

export default withCurrentUser(withRma(Send));



// WEBPACK FOOTER //
// ./app/modules/CustomerRmas/components/Detail/Actions/Send/Send.jsx